/*** user 用户相关接口 ***/
import { http } from '@/api/http';
const config = require('@/config');

export default {
    //获取Users
    queryUsers(data) {
        return http.get('/api/User/Query', data);
    },
    getUserDetail(id) {
        return http.get(`/api/User/${id}`);
    },
    addUser(data) {
        return http.post('/api/User', data, { contentType: 'form' });
    },
    editUser(id, data) {
        return http.put(`/api/User/${id}`, data, { contentType: 'form' });
    },
    deleteUser(id) {
        return http.delete('/api/User/' + id);
    },
    deleteUsers(data) {
        return http.delete('/api/User', data, { contentType: 'form' });
    },
    getUsersDeleted(data) {
        return http.get('/api/User/QueryDeleted', data);
    },
    recoverUser(data) {
        return http.put(`/api/User/Recover`, data, { contentType: 'form' });
    },
    // 永久删除用户
    destroyUser(data) {
        return http.delete('/api/User/destroy', data, { contentType: 'form' });
    },

    //获取用户的菜单
    getUserMenus() {
        return http.get(`/api/User/Menus`);
    },
    getUserRoles(id) {
        return http.get(`/api/User/Roles/${id}`);
    },
    saveUserRoles(id, data) {
        return http.put(`/api/User/Roles/${id}`, data, { contentType: 'form' });
    },

    //用户导入
    uploadUser(fileData) {
        return http.post(`/api/Import/Excel/Users`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },
    uploadStudentUser(fileData) {
        return http.post(`/api/Import/Excel/StudentUsers`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },
    // 新版用户导入（可导入详细信息）
    uploadUserExtend(fileData) {
        return http.post(`/api/Import/Excel/UserExtend`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },
    uploadStudentExtend(fileData) {
        return http.post(`/api/Import/Excel/StudentUsersExtend`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },
    // 导入毕业证书照片
    uploadUserDiploma(fileData) {
        return http.post(`/api/userExtend/uploadZip`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },
    //培训记录
    getTrainRecord(data) {
        return http.get('/api/Training/UserTask', data);
    },

    /*** 用户档案 userExtend ***/
    // getUserExtendInfo(id) {
    //     return http.get(`api/UserExtend/GetUserExtendById/${id}`);
    // },
    getUserArchive(id) {
        return http.get(`/api/archive/GetArchive/${id}`);
    },
    // 修改基本信息
    editBasicArchive(data) {
        return http.put(`/api/userExtend`, data);
    },
    // 毕业证照片上传地址
    uploadDiplomaUrl: `${config.baseUrl}/api/userExtend/uploadDiploma`,
    // 修改岗位信息
    editPostArchive(id, data) {
        return http.put(`/api/userExtend/updPostInfo/${id}`, data,{ contentType: 'form' });
    },

    // 培训记录
    getArchiveTrainRecord(data) {
        return http.get('/api/Training/UserTrainingTask', data);
    },
    // 台账记录
    getArchiveLedgerRecord(id) {
        return http.get(`/api/standing-book/UserStandingBook/${id}`);
    },

    // 工作经历
    getExperienceArchive(id) {
        return http.get(`/api/userExtend/getWorkExperience/${id}`);
    },
    editExperienceArchive(experienceId, data) {
        if (experienceId) {
            return http.put(`/api/userExtend/updWorkExperience/${experienceId}`, data);
        } else {
            return http.post(`/api/userExtend/addWorkExperience`, data);
        }
    },
    deleteExperienceArchive(experienceId) {
        return http.delete(`/api/userExtend/delWorkExperience/${experienceId}`);
    },

    // 质控记录
    getQualityArchive(id) {
        return http.get(`/api/userExtend/getQualityControl/${id}`);
    },
    editQualityArchive(qualityId, data) {
        if (qualityId) {
            return http.put(`/api/userExtend/updQualityControl/${qualityId}`, data);
        } else {
            return http.post(`/api/userExtend/addQualityControl`, data);
        }
    },
    deleteQualityArchive(qualityId) {
        return http.delete(`/api/userExtend/delQualityControl/${qualityId}`);
    },

    // 奖惩信息
    getRewardArchive(id) {
        return http.get(`/api/userExtend/getRewardsPunishments/${id}`);
    },
    editRewardArchive(rewardId, data) {
        if (rewardId) {
            return http.put(`/api/userExtend/updRewardsPunishments/${rewardId}`, data);
        } else {
            return http.post(`/api/userExtend/addRewardsPunishments`, data);
        }
    },
    deleteRewardArchive(rewardId) {
        return http.delete(`/api/userExtend/delRewardsPunishments/${rewardId}`);
    },

    // 修改记录
    getModifyArchive(id) {
        return http.get(`/api/userExtend/GetModifyRecord/${id}`);
    },


    /*** Deprecated 暂时没有用到或弃用的接口 ***/
    //获取用户电子档案
    // getUserArchive(id) {
    //     return http.get(`/api/archive/${id}`);
    // },

}
